import { createContext, useContext, type ReactNode } from 'react'
import type { AdminApiClient } from './AdminApiClient'

// Pages and hooks reach the AdminApiClient instance through this
// context instead of importing a singleton, so tests can swap in a
// purpose-built client (e.g. with a different base URL pointed at MSW)
// without touching the production wiring.

const AdminApiClientContext = createContext<AdminApiClient | null>(null)

interface AdminApiClientProviderProps {
  client: AdminApiClient
  children: ReactNode
}

export function AdminApiClientProvider({
  client, children,
}: AdminApiClientProviderProps) {
  return (
    <AdminApiClientContext.Provider value={client}>
      {children}
    </AdminApiClientContext.Provider>
  )
}

export function useAdminApiClient(): AdminApiClient {
  const client = useContext(AdminApiClientContext)
  if (!client) {
    throw new Error(
      'useAdminApiClient must be used inside <AdminApiClientProvider>',
    )
  }
  return client
}
